import React, { useEffect, useRef } from "react";
import neshan_map_loader from "./loaders/neshan_map_loader";

const NeshanMap = props => {
    const {
        style,
        options,
        onInit
    } = props;
    const mapEl = useRef(null);
    const defaultStyle = {
        width: "100%",
        height: "400px",
        margin: 0,
        padding: 0,
        background: "#eee"
    };
    const defaultOptions = {
        key: "web.165abefc7b50457aa80c25d47ae4fa10",
        maptype: "dreamy",
        poi: true,
        traffic: false,
        center: [35.7, 51.4],
        zoom: 0
    };
    useEffect(() => {
        neshan_map_loader({
            onLoad: () => {
                let map = new window.L.Map(mapEl.current, {
                    ...defaultOptions,
                    ...options
                });
                if (onInit) onInit(window.L, map);
            },
            onError: () => {
                console.error("Neshan Maps Error: This page didn't load Neshan Maps correctly");
            }
        });
    }, []);
    return /*#__PURE__*/React.createElement("div", {
        ref: mapEl,
        style: {
            ...defaultStyle,
            ...style
        }
    });
};

export default NeshanMap;